import React from "react";
import { useDispatch } from "react-redux";

import ModalWrapper from "components/lib/Shared/ModalWrapper";
import Button from "components/lib/Shared/Button";
import { closeModal } from "state/slices/modals";

function ChangeOfNationalityConfirmationModal({
  modalName,
  handleChangeOfNationality = () => null,
  selectedNationality = null,
}) {
  const dispatch = useDispatch();
  return (
    <ModalWrapper
      name={modalName}
      title="Change of Nationality"
      maxWidth="sm:max-w-[29%]"
      titleColor="text-[#FA3F3F]"
      isInChangeOfNationalityModal
    >
      <div className="my-8 text-lg">
        Are you sure you want to change your nationality to{" "}
        <span className="font-bold" style={{ color: "sflPrimary" }}>
          {selectedNationality || "the selected value"}
        </span>
        ?
      </div>
      <hr />
      <div className="flex justify-between mt-4">
        <Button
          onClick={() => dispatch(closeModal(modalName))}
          variant="outline"
          className="text-sflPrimary border-sflPrimary"
        >
          Cancel
        </Button>
        <Button onClick={handleChangeOfNationality} loadingText="Confirming...">
          I confirm
        </Button>
      </div>
    </ModalWrapper>
  );
}

export default ChangeOfNationalityConfirmationModal;
